export default {
      id: "icon-internal-link-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-internal-link",
      toString: function () {
        return this.url;
      }
    }